import { type Theme } from '@wix/chat-widget-common-widgets';
import { Box } from '@wix/design-system';
import cs from 'classnames';
import React, { type ReactNode } from 'react';
import s from './CardLayout.module.scss';

export const CardLayout = (props: { children: ReactNode; theme: Theme }) => {
  const className = cs(s.container, {
    [s.containerDark]: props.theme === 'dark',
  });

  return (
    <Box direction="vertical" gap="8px" padding="SP2" className={className}>
      {props.children}
    </Box>
  );
};
